import { ModifierGroupState } from './modifier-group-reducer';
import { MODIFIER_GROUP_ACTION_TYPE, ModifierGroup, ModifierGroupActions, ModifierGroupFormPayload, ModifierGroupPaginationParams } from './modifier-group-type';

export const modifierGroupCreators = {
  setModifierGroupState: <KeyName extends keyof ModifierGroupState>(
    key: KeyName,
    value: ModifierGroupState[KeyName]
  ): ModifierGroupActions => ({
    type: MODIFIER_GROUP_ACTION_TYPE.SET_MODIFIER_GROUP_STATE,
    payload: { key, value },
  }),
  callModifierGroups: (params?: ModifierGroupPaginationParams) => ({
    type: MODIFIER_GROUP_ACTION_TYPE.CALL_MODIFIER_GROUPS,
    payload: params,
  }),
  callDeleteModifierGroup: (id: number) => ({
    type: MODIFIER_GROUP_ACTION_TYPE.CALL_DELETE_MODIFIER_GROUP,
    payload: { id },
  }),
  callAllModifierGroups: (onSuccessCallback: (groups: ModifierGroup[]) => void) => ({
    type: MODIFIER_GROUP_ACTION_TYPE.CALL_ALL_MODIFIER_GROUPS,
    payload: { onSuccessCallback },
  }),
  callCreateModifierGroup: (data: ModifierGroupFormPayload, onSuccess: () => void, onError?: (translationKeys: string[]) => void) => ({
    type: MODIFIER_GROUP_ACTION_TYPE.CALL_CREATE_MODIFIER_GROUP,
    payload: { data, onSuccess, onError },
  }),
  callUpdateModifierGroup: (data: ModifierGroupFormPayload & { menuModifierGroupId: number }, onSuccess: () => void, onError?: (translationKeys: string[]) => void) => ({
    type: MODIFIER_GROUP_ACTION_TYPE.CALL_UPDATE_MODIFIER_GROUP,
    payload: { data, onSuccess, onError },
  }),
};
